import { Grid } from '@material-ui/core';
import { BackButton } from '../BackButton/BackButton';
import { Heading, TextBlock } from 'neon-design-system';
import { config } from '../../config';
import { RequestsListTile } from '../RequestsListTile/RequestsListTile';
import { baseUrls } from '../../constants/urls';

const getPageDetails = (path: string) => {
  switch (path) {
    case baseUrls.accountChangeRequests:
    case baseUrls.accountChangeRequest:
      return {
        title: 'Account changes',
        subtitle: 'Below is a list of your requests to transfer trades between accounts.'
      };

    case baseUrls.riskLimitsRequests:
    case baseUrls.manageAccountLimits:
    case baseUrls.riskLimitsRequest:
    case baseUrls.manageAccountLimit:
      return {
        title: 'Risk limits',
        subtitle: 'Monitor you risk limit change requests across your accounts on several ISVs.'
      };

    case baseUrls.kybRequests:
    case baseUrls.newKybSubmission:
    case baseUrls.signDocument:
      return {
        title: 'Your KYB requests',
        subtitle: 'Monitor all your KYB form submissions to the Marex Capital Markets onboarding team.'
      };

    case baseUrls.cashMovementRequests:
    case baseUrls.cashMovementRequest:
    case baseUrls.cashMovementNewRequest.replace(':paymentType', 'withdrawal'):
    case baseUrls.cashMovementNewRequest.replace(':paymentType', 'ach-pull'):
    case baseUrls.cashMovementBulkRequest:
    case baseUrls.cashMovementNewRequestSubmitted.replace(':paymentType', 'withdrawal'):
    case baseUrls.cashMovementNewRequestSubmitted.replace(':paymentType', 'ach-pull'):
      return {
        title: 'Cash Movements',
        subtitle: 'Below is a list of your requests to move cash.'
      };

    default:
      return {
        title: '',
        subtitle: ''
      };
  }
};

interface Props {
  path: string;
}
export const RestrictedAccessMobileView = ({ path }: Props) => {
  const { title, subtitle } = getPageDetails(path);
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <BackButton to={'/'} pageName="Support Center" />
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Heading styleName="largeTitle" xs="small">
              {title}
            </Heading>
          </Grid>
          <Grid item xs={12}>
            <TextBlock styleName="largeBody2" xs="small" shade={400}>
              {subtitle}
            </TextBlock>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <RequestsListTile
          title="Access restricted"
          subtitle="You currently don’t have permission to access this area of Neon Support Center. Should you require access, please contact Support below."
          buttonText="Contact Support"
          onClick={() => (window.location.href = `mailto:${config.contactSupportEmail}`)}
        />
      </Grid>
    </Grid>
  );
};
